import { config } from '../../config';

export const getProducts = () => config.products;
